import { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router'
import { useAuth } from 'resources/Auth'

// Roles that can open a merchant's settings, and the pages only reachable from
// them (fee group, risk profile limits/options, PxSuite products). Many
// controls there have no role gate of their own, so the route is the gate.
export const MERCHANT_SETTINGS_ROLES = [
  'main_admin',
  'operations_specialist',
  'growth_specialist',
  'developer',
]

// Reads roles from a single auth snapshot (see FinancePricing/useAccess.ts for
// why not `useACL`). Renders nothing until the user has loaded so ungated
// controls never flash for a role that is about to be redirected.
export default function RequireSettingsAccess({
  children,
}: {
  children: ReactNode
}) {
  const { merchantId } = useParams()
  const {
    data: { user },
  } = useAuth()

  if (!user) {
    return null
  }

  const roles: string[] = user.user?.roles ?? []
  if (!MERCHANT_SETTINGS_ROLES.some(role => roles.includes(role))) {
    return <Navigate to={`/merchants/${merchantId}`} replace />
  }

  return <>{children}</>
}
